import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Header from './components/Header';
import Home from './pages/Home';
import FormPage from './pages/FormPage';
import DetailsPage from './pages/DetailsPage';
import DashboardPage from './pages/DashboardPage';
import PersonPage from './pages/PersonPage';
import PreviewPage from './pages/PreviewPage';
import AdminPage from './pages/AdminPage';
import FriendsPage from './pages/FriendsPage';
import FriendCollectionPage from './pages/FriendCollectionPage';
import FriendMediaDetailsPage from './pages/FriendMediaDetailsPage';
import SuggestionsPage from './pages/SuggestionsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import './index.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Header />
          <Routes>
            {/* Rotas públicas */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            
            {/* Rotas protegidas */}
            <Route path="/" element={
              <PrivateRoute>
                <Home />
              </PrivateRoute>
            } />
            <Route path="/add" element={
              <PrivateRoute>
                <FormPage />
              </PrivateRoute>
            } />
            <Route path="/edit/:id" element={
              <PrivateRoute>
                <FormPage />
              </PrivateRoute>
            } />
            <Route path="/details/:id" element={
              <PrivateRoute>
                <DetailsPage />
              </PrivateRoute>
            } />
            <Route path="/profile" element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            } />
            <Route path="/dashboard" element={
              <PrivateRoute>
                <DashboardPage />
              </PrivateRoute>
            } />
            <Route path="/person/:name" element={
              <PrivateRoute>
                <PersonPage />
              </PrivateRoute>
            } />
            <Route path="/preview/:tmdbId" element={
              <PrivateRoute>
                <PreviewPage />
              </PrivateRoute>
            } />
            <Route path="/admin" element={
              <PrivateRoute>
                <AdminPage />
              </PrivateRoute>
            } />
            <Route path="/friends" element={
              <PrivateRoute>
                <FriendsPage />
              </PrivateRoute>
            } />
            <Route path="/suggestions" element={
              <PrivateRoute>
                <SuggestionsPage />
              </PrivateRoute>
            } />
            <Route path="/friend/:friendId" element={
              <PrivateRoute>
                <FriendCollectionPage />
              </PrivateRoute>
            } />
            <Route path="/friend/:friendId/media/:mediaId" element={
              <PrivateRoute>
                <FriendMediaDetailsPage />
              </PrivateRoute>
            } />
            
            {/* Rota padrão */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
